/*********************** Custom JS for Boost AI Search & Discovery  ************************/
let movedToolbar = false;
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    (componentRegistry) => {
        /* Boost-610623 */
        componentRegistry.useComponentPlugin('Toolbar', {
            name: 'Custom Toolbar position',
            enabled: true,
            apply: () => ({
                afterRender(element) {
                    try {
                        const toolbar = document.querySelector('.boost-sd__toolbar-container');
                        const gridLayout = document.querySelector('.boost-sd-layout');
                        if (toolbar && gridLayout && !movedToolbar) {
                            movedToolbar = true;
                            gridLayout.before(toolbar);
                            // gridLayout.insertBefore(toolbar, gridLayout);
                        }
                    } catch (error) {
                        console.log(error);
                    }
                }
            })
        });
        // componentRegistry.useModulePlugin('CartAPI', {
        //     name: 'Integrate theme cart',
        //     apply(builder) {
        //         builder.on('methodFulfilled', 'addToCart', async (payload) => {
        //             setTimeout(function () {
        //               document.querySelector('a[href="/cart"]').click();
        //             }, 500)
        //             return payload;
        //         });
        //     },
        // });
    }
]);

const customizeProductItem = {
  addTextToPrice: (componentRegistry) => {
        componentRegistry.useComponentPlugin('ProductItemWidget', {
            name: 'Add text to price',
            enabled: true,
            apply: () => ({
                afterRender(element) {
                      try {
                        let productData = element.getParams()?.props?.product 
                        let productItem = document.querySelector('[data-product-id="' + productData.id + '"]');
              
                        if (!productItem) return;

                        let price = productItem.querySelector('.boost-sd__product-price')

                        if (price && !price.hasAttribute('added-text')) {
                            price.setAttribute('added-text', true );
                            let newText = `<span class="extra-price-text">From</span> `;
                            price.insertAdjacentHTML('afterbegin', newText);
                        }

                      } catch (e) {
                        console.log(e)
                      }
                },
            }),
        });
    }
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  customizeProductItem.addTextToPrice,
]);